import React from 'react'

import LandingCreationContainer from '../components/landing-manager/LandingCreationContainer'

const LandingCreationScreen = props => <LandingCreationContainer {...props} />

export default LandingCreationScreen
